import {Trans} from 'react-i18next'

export const AssignmentCardLink = ({
    taskCategoryName,
    pdfLink
}: {
    taskCategoryName: string
    pdfLink: string | null | undefined
}) => (
    <div className="text-sm [&_a]:cursor-pointer [&_a]:font-medium [&_a]:text-purple-700 [&_a]:underline">
        <Trans
            i18nKey={
                taskCategoryName == 'Host'
                    ? 'assignment:shootlist_card:review_link'
                    : 'assignment:review_guidelines_link'
            }
            values={{category: taskCategoryName}}
            components={{
                a: <a href={pdfLink ?? ''} target="_blank" />
            }}
        />
    </div>
)
